import { Reducer } from 'redux';
import { ProcessingRequestActions, ProcessingRequestActionType } from 'redux/actions/ProcessingRequestActions';

const initialState: boolean = false;

export const processingRequestReducer: Reducer<boolean, ProcessingRequestActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case ProcessingRequestActionType.ACTIVE:
                {
                    return true;
                }
            case ProcessingRequestActionType.DONE:
                {
                    return false;
                }
            default:
                return state;
        }
    };
